<template>
  <div class="game-container">
    <Appbar routeNameProps="dsfGameList?type=sports" :title="typeName">
      <span v-if="showBottomTab" text slot="left"></span>
    </Appbar>
    <div class="bannerSwiperContainer">
      <swiper :options="bannerSwiperOption">
        <swiper-slide v-for="(item, i) in bannerArray" :key="i">
          <img style="width:100%" :src="item.imgUrl" />
        </swiper-slide>
        <div class="swiper-pagination bannerSwiperPagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="realman-transfer" v-if="$route.query.type == 'realman'">
      <v-btn
        @click="toTransfer"
        :style="
          `color: ${$vuetify.theme.themes.light.front};background-color:${$vuetify.theme.themes.light.buttonColor ||
            $vuetify.theme.themes.light.headerBgColor}`
        "
      >
        额度转换
      </v-btn>
    </div>
    <ul class="game-list">
      <li v-for="(item, i) in platformList" :key="i" @click="$refs.preStartGame.gameItem(item, $route.query.type)">
        <img :src="_cdn + '/app/dsf_game/logo/' + item.platformCode + '-min.png'" alt="" />
        <p>{{ item.platformName }}</p>
      </li>
    </ul>
    <preStartGame ref="preStartGame"></preStartGame>
    <BottomTab slot="list-bottom" />
  </div>
</template>

<script>
import Appbar from '@c/layout/Appbar'
import appConfig from '@c/mixins/appConfig.mixins'
import preStartGame from '@c/game/preStartGame'
import BottomTab from '@c/layout/BottomTab'
import { ApigetLoopimgList } from '@/api/service.js'
export default {
  mixins: [appConfig],
  components: { Appbar, preStartGame, BottomTab },
  data() {
    return {
      bannerSwiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.bannerSwiperPagination'
        }
      },
      bannerArray: [],
      platformList: ''
    }
  },
  watch: {
    $route() {
      this.getList()
    }
  },
  computed: {
    typeName() {
      return this.$route.query.name
    },
    cdn() {
      return this.$store.getters['app/cdn']
    }
  },
  methods: {
    toTransfer() {
      const TOKEN = this.$store.state.user.token
      const memberType = this.$store.state.user.userInfo.memberType
      if (!TOKEN) {
        return this.$toast('请登录后操作')
      }
      if (memberType == 3) {
        return this.$toast('试玩账号无此权限')
      }
      if (memberType == 4) {
        return this.$toast('推广账号无此权限')
      }
      this.$router.push('/Transfer')
    },
    getList(type) {
      type = this.$route.query.type
      switch (type) {
        case 'realman':
          this.platformList = this.$store.getters['thirdparty/getRealmanPlatformList']
          break
        case 'sports':
          this.platformList = this.$store.getters['thirdparty/getSportsPlatformList']
          break
        case 'elegameSports':
          this.platformList = this.$store.getters['thirdparty/getDianjingPlatformList']
          break
      }
    },
    getLoopimgList() {
      ApigetLoopimgList().then(data => {
        if (data.code == '12200') {
          this.bannerArray = [...data.data]
        }
      })
    }
  },
  async created() {
    await this.$store.dispatch('thirdparty/getPlatformList')
    this.getLoopimgList()
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.game-container {
  background-color: #fff;
  height: 100%;
  overflow: scroll;
  .bannerSwiperContainer {
    .bannerSwiperPagination {
      bottom: 10px;
      width: 100%;
      text-align: center;
      .swiper-pagination-bullet-active {
        opacity: 0.6;
        background: #000;
      }
    }
    .swiper-container {
      height: 142px;
    }
    .bannerSwiper_img {
      width: 100%;
      height: 100%;
    }
  }
  .game-list {
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    padding-top: 10px;
    li {
      width: 25%;
      padding: 2%;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 60px;
      }
    }
  }
}
.realman-transfer {
  display: flex;
  padding: 5px;
  justify-content: flex-end;
  border-bottom: 1px solid #eee;
}
</style>
